import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';

import FileInputPreview from './FileInputPreview';

const defaultStyle = {
  dropZone: {
    background: '#efefef',
    cursor: 'pointer',
    padding: '1rem',
    textAlign: 'center',
    color: '#999',
  },
  preview: {
    float: 'left',
  },
};

export class FileInput extends Component {
  static propTypes = {
    accept: PropTypes.string,
    children: PropTypes.element,
    disableClick: PropTypes.bool,
    elStyle: PropTypes.object,
    input: PropTypes.object,
    itemStyle: PropTypes.object,
    label: PropTypes.string,
    maxSize: PropTypes.number,
    minSize: PropTypes.number,
    multiple: PropTypes.bool,
    removeStyle: PropTypes.object,
    style: PropTypes.object,
    placeholder: PropTypes.node,
  };

  static defaultProps = {
    addLabel: true,
    addField: true,
    label: 'Try dropping image file here, or click to select file to upload',
    multiple: false,
    onUpload: () => {
    },
    itemStyle: {
      display: 'inline-block',
      position: 'relative',
    },
    removeStyle: {
      position: 'absolute',
      top: '0.5rem',
      right: '0.5rem',
      minWidth: '2rem',
      opacity: 0,
    },
  };

  state = {
    file: null,
  };

  revokeFilePreview = () => {
    const { file } = this.state;
    if (file && file.preview) {
      window.URL.revokeObjectURL(file.preview);
    }
  };

  componentWillUnmount() {
    this.revokeFilePreview()
  };

  onDrop = (files) => {
    this.revokeFilePreview();

    const transformedFile = this.transformFile(files[0]);

    this.setState({ file: transformedFile });
    this.props.input.onChange(transformedFile);
  };

  onRemove = file => () => {
    this.revokeFilePreview();

    this.setState({ file: null });
    this.props.input.onChange(null);
  };

  transformFile = (file) => {
    if (!(file instanceof File)) {
      return file;
    }

    const { source, title } = React.Children.toArray(this.props.children)[0].props;

    file[source] = file.preview;

    if (title) {
      file[title] = file.name;
    }

    return file;
  };

  label() {
    const { placeholder, label } = this.props;

    if (placeholder) {
      return placeholder;
    }


    return (
      <p>{label}</p>
    );
  }

  render() {
    const {
      accept,
      children,
      disableClick,
      elStyle,
      itemStyle,
      maxSize,
      minSize,
      multiple,
      style,
      removeStyle,
    } = this.props;

    const finalStyle = {
      ...defaultStyle,
      ...style,
    };

    return (
      <div style={elStyle}>
        <Dropzone
          onDrop={this.onDrop}
          accept={accept}
          disableClick={disableClick}
          maxSize={maxSize}
          minSize={minSize}
          multiple={multiple}
          style={finalStyle.dropZone}
        >
          {this.label()}
        </Dropzone>
        { children && (
          <div className="previews">
              <FileInputPreview
                file={this.state.file}
                itemStyle={itemStyle}
                onRemove={this.onRemove(this.state.file)}
                removeStyle={removeStyle}
              >
                {React.cloneElement(children, {
                  record: this.state.file,
                  style: defaultStyle.preview,
                })}
              </FileInputPreview>
          </div>
        ) }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/input/FileInput.js